var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('home-app-bar'),_c('home-view'),_c('home-footer'),_c('floating-contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }